var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_2587)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7243 15.6773C10.7043 15.6398 7.8136 15.2403 4.78619 12.2135C1.75948 9.18613 1.36069 6.29613 1.32244 5.27542C1.26577 3.71992 2.45719 2.20905 3.83348 1.61901C3.99921 1.54744 4.18071 1.52019 4.36015 1.53994C4.53959 1.55968 4.71081 1.62574 4.85702 1.73163C5.99035 2.55755 6.77235 3.80705 7.44385 4.78951C7.5916 5.00536 7.65477 5.26802 7.62133 5.52745C7.58789 5.78687 7.46018 6.02493 7.26252 6.19626L5.88056 7.22263C5.8138 7.27084 5.7668 7.34165 5.7483 7.4219C5.7298 7.50215 5.74106 7.58639 5.77998 7.65896C6.09306 8.22776 6.64981 9.07492 7.28731 9.71242C7.92552 10.3499 8.81235 10.9435 9.42081 11.292C9.4971 11.3348 9.5869 11.3468 9.67174 11.3255C9.75659 11.3041 9.83003 11.2511 9.87698 11.1773L10.7766 9.80805C10.9419 9.58836 11.1859 9.44118 11.4574 9.39734C11.7289 9.35351 12.0068 9.41641 12.2329 9.57288C13.2295 10.2628 14.3926 11.0313 15.244 12.1215C15.3585 12.2687 15.4313 12.444 15.4549 12.6291C15.4784 12.8141 15.4518 13.0021 15.3779 13.1733C14.785 14.5567 13.2848 15.7347 11.7243 15.6773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_2587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLeft);
export default __webpack_public_path__ + "static/media/phone-left.ddd66507c943568a3fc6b82daad4d960.svg";
export { ForwardRef as ReactComponent };